/**
 * Maps a scripted beat id to the human-readable sentence that describes
 * what the player was doing when that beat unlocked its term.
 * Renders in the Field Guide beat of the EndingScene.
 *
 * Keys must match `ScriptedBeat.id` values in `./beats.ts`.
 */
export const FIELD_GUIDE_CONTEXT: Record<string, string> = {
  'beat-1-aging':     'first look at the aging report',
  'beat-2-dunning':   "first dunning run on Acme's 90+ bucket",
  'beat-3-cash-app':  "Peak Industries' wire came in",
  'beat-4-short-pay': 'TechStart paid $4,200 on $5,000',
  'beat-5-dispute':   "Acme's email: \"we never signed for the 4/11 run\"",
};
